import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { PREDICTIONS_QUERY_KEYS } from "@/features/predictions/constants/queryKeys";
import { lotsService } from "@/features/predictions/services/lots.service";
import type { Lot } from "@/features/predictions/types/lot.type";

const STALE_TIME_MS = 60 * 1000;

export const useCompetitionLots = (
  competitionId: string | undefined,
): UseQueryResult<Lot[]> => {
  return useQuery<Lot[]>({
    queryKey: PREDICTIONS_QUERY_KEYS.competitionLots(competitionId),
    queryFn: () => lotsService.getCompetitionLots(competitionId as string),
    enabled: Boolean(competitionId),
    staleTime: STALE_TIME_MS,
    select: (lots) => [...lots].sort((a, b) => a.rankPosition - b.rankPosition),
  });
};
